import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { OrdersComponent } from "./orders/orders.component";
import { OrderDetailsComponent } from "./order-details/order-details.component";
import { OrdersIdeaComponent } from "./orders-idea/orders-idea.component";
import { OrderUpdateComponent } from "./order-update/order-update.component";
import { OrderTransportDetailsComponent } from "./order-transport-details/order-transport-details.component";
import { OrderTransportUpdateComponent } from "./order-transport-update/order-transport-update.component";

export const ORDER_ROUTES: Routes = [
  {
    path: 'orders',
    pathMatch: 'full',
    redirectTo: 'orders/overview'
  },
  {
    path: 'orders/overview',
    component: OrdersComponent,
    canActivate: [authGuard]
  },
  {
    path: 'orders/idea',
    component: OrdersIdeaComponent,
    canActivate: [authGuard]
  },
  {
    path: 'order/details/:prid/:ordid',
    component: OrderDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'order/update/:prid/:jobid/:ordid',
    component: OrderUpdateComponent,
    canActivate: [authGuard]
  },
  {
    path: 'transport/details/:prid/:jobid/:transportid/:orderid',
    component: OrderTransportDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'transport/update/:prid/:jobid/:transportid/:orderid',
    component: OrderTransportUpdateComponent,
    canActivate: [authGuard]
  }
]
